import useCurrency from '../hooks/useCurrency';

/**
 * The "Starting price / user / month" row in a competitor comparison table.
 *
 * TeamGrid's figure follows the visitor's detected currency, exactly like every
 * other price on the site — an Indian visitor previously read $6.99 here while
 * the rest of the site quoted them ₹299.
 *
 * The competitor figure does NOT convert. It is that vendor's published list
 * price, and inventing an INR equivalent would be stating a price they may not
 * charge. It stays in USD, and picks up an explicit "USD" marker whenever the
 * visitor isn't already seeing USD, so a mixed-currency row can't be misread.
 *
 * @param {string} competitor - the vendor's published price, e.g. '$4.99'
 */
export default function StartingPriceRow({ competitor }) {
  const { currency, symbol, price } = useCurrency();
  const needsCurrencyTag = currency !== 'USD';

  return (
    <tr>
      <td>Starting price / user / month</td>
      <td className="tg">
        <span style={{ fontWeight: '700' }}>{symbol}{price('standard')}</span>
      </td>
      <td>
        <span style={{ fontWeight: '700' }}>{competitor}</span>
        {needsCurrencyTag && <span className="cmp-cur"> USD</span>}
      </td>
    </tr>
  );
}
